/**
 * Legal Document Versions
 * These should be updated whenever the Terms of Service or Privacy Policy are modified.
 * This ensures that user acceptance is recorded against the correct version in the database.
 */
export const LEGAL_VERSIONS = {
  TOS: 'v2026.01.03', // Matches 'January 3, 2026' update
  PRIVACY: 'v2024.09.26', // Matches 'September 2024' update
};
